/* eslint-disable no-nested-ternary */
import React, { FunctionComponent, useState } from 'react';
import * as vp from 'vopay';
import styles from './DonutContainer.module.scss';
import AccountsOverviewTable from '../Accounts/AccountsOverviewTable';
import { AccountOverviewChartData, periodOptions, transactionOptions } from '../Accounts/AccountOverviewData';
import { Trans } from 'react-i18next';

const { Select, Donut } = vp;

export type DonutcontainerProps = {
  accountsData: {
    Statistics: {
      [StatType: string]: {
        numOfData: {
          yearly: number;
          monthly: number;
          weekly: number;
        };
        volOfData: {
          yearly: number;
          monthly: number;
          weekly: number;
        };
      };
    };
  };
};

type FC = FunctionComponent<DonutcontainerProps>;

const DonutContainer: FC = ({ accountsData }: DonutcontainerProps) => {
  const [period, setPeriod] = useState<string>('Mo');

  const handlePeriodChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPeriod(event.currentTarget.value);
  };

  const statusOrder = ['pending', 'inProgress', 'complete'];

  const handleDonutData = () => {
    const periodKey =
      period === Object.keys(periodOptions)[0]
        ? 'monthly'
        : period === Object.keys(periodOptions)[1]
          ? 'yearly'
          : 'weekly';

    const AccountOverviewDataValue = statusOrder.map((status) =>
      Number(accountsData.Statistics[status]?.volOfData[periodKey] ?? 0),
    );
    return AccountOverviewDataValue;
  };

  return (
    <div className={styles.doughnutContainer}>
      <div className={styles.chartContainer}>
        <div className={styles.selectContainer}>
          <Select
            variant="chart"
            options={periodOptions}
            placeholder={periodOptions.Mo}
            name="accounts-overview-period-select"
            value={period}
            onBlur={() => {}}
            onChange={handlePeriodChange}
          />
        </div>
        <div className={styles.total}>
          <h5>
            <Trans i18nKey="HomePage.AccountOverviewWidget.ActiveTab.Chart.title" components={{ b: <b /> }} />
          </h5>
          <span>
            $
            {(() => {
              const periodKey =
                period === Object.keys(periodOptions)[0]
                  ? 'monthly'
                  : period === Object.keys(periodOptions)[1]
                    ? 'yearly'
                    : 'weekly';

              return statusOrder
                .map((status) => Number(accountsData.Statistics[status]?.numOfData[periodKey] ?? 0))
                .reduce((res, num) => res + num, 0)
                .toLocaleString();
            })()}
          </span>
        </div>
        <Donut AccountOverviewChartData={AccountOverviewChartData} handleDonutData={handleDonutData()} />
      </div>

      <div className={styles.tableContainer}>
        <AccountsOverviewTable
          period={period}
          periodOptions={periodOptions}
          transactionOptions={transactionOptions}
          statusOrder={statusOrder}
          accountsData={accountsData}
        />
      </div>
    </div>
  );
};

export default DonutContainer;
